module.exports = __webpack_public_path__ + "static/img/bg_water.c52bd0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/backgrounds/thumbnail/bg_water.png
// module id = akK9
// module chunks = 0